// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `[dir=rtl] table, [dir=rtl] th, [dir=rtl] tr, [dir=rtl] td {
  text-align: right;
}
[dir=rtl] .float-left {
  float: initial;
  float: right;
}
[dir=rtl] .float-right {
  float: initial;
  float: left;
}
[dir=rtl] .ml-auto {
  margin-left: 0 !important;
  margin-right: auto !important;
}
[dir=rtl] .ml-1 {
  margin-left: 0 !important;
  margin-right: 8px !important;
}
[dir=rtl] .ml-2 {
  margin-left: 0 !important;
  margin-right: 16px !important;
}
[dir=rtl] .ml-3 {
  margin-left: 0 !important;
  margin-right: 24px !important;
}
[dir=rtl] .ml-4 {
  margin-left: 0 !important;
  margin-right: 32px !important;
}
[dir=rtl] .ml-5 {
  margin-left: 0 !important;
  margin-right: 40px !important;
}
[dir=rtl] .mr-1 {
  margin-right: 0 !important;
  margin-left: 8px !important;
}
[dir=rtl] .mr-2 {
  margin-right: 0 !important;
  margin-left: 16px !important;
}
[dir=rtl] .mr-3 {
  margin-right: 0 !important;
  margin-left: 24px !important;
}
[dir=rtl] .mr-4 {
  margin-right: 0 !important;
  margin-left: 32px !important;
}
[dir=rtl] .mr-5 {
  margin-right: 0 !important;
  margin-left: 40px !important;
}
[dir=rtl] .ml-5px {
  margin-left: 0 !important;
  margin-right: 5px !important;
}
[dir=rtl] .ml-6px {
  margin-left: 0 !important;
  margin-right: 6px !important;
}
[dir=rtl] .ml-7px {
  margin-left: 0 !important;
  margin-right: 7px !important;
}
[dir=rtl] .ml-8px {
  margin-left: 0 !important;
  margin-right: 8px !important;
}
[dir=rtl] .ml-9px {
  margin-left: 0 !important;
  margin-right: 9px !important;
}
[dir=rtl] .ml-10px {
  margin-left: 0 !important;
  margin-right: 10px !important;
}
[dir=rtl] .ml-11px {
  margin-left: 0 !important;
  margin-right: 11px !important;
}
[dir=rtl] .ml-12px {
  margin-left: 0 !important;
  margin-right: 12px !important;
}
[dir=rtl] .ml-13px {
  margin-left: 0 !important;
  margin-right: 13px !important;
}
[dir=rtl] .ml-14px {
  margin-left: 0 !important;
  margin-right: 14px !important;
}
[dir=rtl] .ml-15px {
  margin-left: 0 !important;
  margin-right: 15px !important;
}
[dir=rtl] .ml-16px {
  margin-left: 0 !important;
  margin-right: 16px !important;
}
[dir=rtl] .ml-17px {
  margin-left: 0 !important;
  margin-right: 17px !important;
}
[dir=rtl] .ml-18px {
  margin-left: 0 !important;
  margin-right: 18px !important;
}
[dir=rtl] .ml-19px {
  margin-left: 0 !important;
  margin-right: 19px !important;
}
[dir=rtl] .ml-20px {
  margin-left: 0 !important;
  margin-right: 20px !important;
}
[dir=rtl] .ml-21px {
  margin-left: 0 !important;
  margin-right: 21px !important;
}
[dir=rtl] .ml-22px {
  margin-left: 0 !important;
  margin-right: 22px !important;
}
[dir=rtl] .ml-23px {
  margin-left: 0 !important;
  margin-right: 23px !important;
}
[dir=rtl] .ml-24px {
  margin-left: 0 !important;
  margin-right: 24px !important;
}
[dir=rtl] .ml-25px {
  margin-left: 0 !important;
  margin-right: 25px !important;
}
[dir=rtl] .ml-26px {
  margin-left: 0 !important;
  margin-right: 26px !important;
}
[dir=rtl] .ml-27px {
  margin-left: 0 !important;
  margin-right: 27px !important;
}
[dir=rtl] .ml-28px {
  margin-left: 0 !important;
  margin-right: 28px !important;
}
[dir=rtl] .ml-29px {
  margin-left: 0 !important;
  margin-right: 29px !important;
}
[dir=rtl] .ml-30px {
  margin-left: 0 !important;
  margin-right: 30px !important;
}
[dir=rtl] .mr-5px {
  margin-right: 0 !important;
  margin-left: 5px !important;
}
[dir=rtl] .mr-6px {
  margin-right: 0 !important;
  margin-left: 6px !important;
}
[dir=rtl] .mr-7px {
  margin-right: 0 !important;
  margin-left: 7px !important;
}
[dir=rtl] .ml-8px {
  margin-right: 0 !important;
  margin-left: 8px !important;
}
[dir=rtl] .mr-9px {
  margin-right: 0 !important;
  margin-left: 9px !important;
}
[dir=rtl] .mr-10px {
  margin-right: 0 !important;
  margin-left: 10px !important;
}
[dir=rtl] .mr-11px {
  margin-right: 0 !important;
  margin-left: 11px !important;
}
[dir=rtl] .mr-12px {
  margin-right: 0 !important;
  margin-left: 12px !important;
}
[dir=rtl] .mr-13px {
  margin-right: 0 !important;
  margin-left: 13px !important;
}
[dir=rtl] .mr-14px {
  margin-right: 0 !important;
  margin-left: 14px !important;
}
[dir=rtl] .mr-15px {
  margin-right: 0 !important;
  margin-left: 15px !important;
}
[dir=rtl] .mr-16px {
  margin-right: 0 !important;
  margin-left: 16px !important;
}
[dir=rtl] .mr-17px {
  margin-right: 0 !important;
  margin-left: 17px !important;
}
[dir=rtl] .mr-18px {
  margin-right: 0 !important;
  margin-left: 18px !important;
}
[dir=rtl] .mr-19px {
  margin-right: 0 !important;
  margin-left: 19px !important;
}
[dir=rtl] .mr-20px {
  margin-right: 0 !important;
  margin-left: 20px !important;
}
[dir=rtl] .mr-21px {
  margin-right: 0 !important;
  margin-left: 21px !important;
}
[dir=rtl] .mr-22px {
  margin-right: 0 !important;
  margin-left: 22px !important;
}
[dir=rtl] .mr-23px {
  margin-right: 0 !important;
  margin-left: 23px !important;
}
[dir=rtl] .mr-24px {
  margin-right: 0 !important;
  margin-left: 24px !important;
}
[dir=rtl] .mr-25px {
  margin-right: 0 !important;
  margin-left: 25px !important;
}
[dir=rtl] .mr-26px {
  margin-right: 0 !important;
  margin-left: 26px !important;
}
[dir=rtl] .mr-27px {
  margin-right: 0 !important;
  margin-left: 27px !important;
}
[dir=rtl] .mr-28px {
  margin-right: 0 !important;
  margin-left: 28px !important;
}
[dir=rtl] .mr-29px {
  margin-right: 0 !important;
  margin-left: 29px !important;
}
[dir=rtl] .mr-30px {
  margin-right: 0 !important;
  margin-left: 30px !important;
}
[dir=rtl] .pr-5px {
  padding-right: 0;
  padding-left: 5px;
}
[dir=rtl] .pr-6px {
  padding-right: 0;
  padding-left: 6px;
}
[dir=rtl] .pr-7px {
  padding-right: 0;
  padding-left: 7px;
}
[dir=rtl] .pr-8px {
  padding-right: 0;
  padding-left: 8px;
}
[dir=rtl] .pr-9px {
  padding-right: 0;
  padding-left: 9px;
}
[dir=rtl] .pr-10px {
  padding-right: 0;
  padding-left: 10px;
}
[dir=rtl] .pr-11px {
  padding-right: 0;
  padding-left: 11px;
}
[dir=rtl] .pr-12px {
  padding-right: 0;
  padding-left: 12px;
}
[dir=rtl] .pr-13px {
  padding-right: 0;
  padding-left: 13px;
}
[dir=rtl] .pr-14px {
  padding-right: 0;
  padding-left: 14px;
}
[dir=rtl] .pr-15px {
  padding-right: 0;
  padding-left: 15px;
}
[dir=rtl] .pr-16px {
  padding-right: 0;
  padding-left: 16px;
}
[dir=rtl] .pr-17px {
  padding-right: 0;
  padding-left: 17px;
}
[dir=rtl] .pr-18px {
  padding-right: 0;
  padding-left: 18px;
}
[dir=rtl] .pr-19px {
  padding-right: 0;
  padding-left: 19px;
}
[dir=rtl] .pr-20px {
  padding-right: 0;
  padding-left: 20px;
}
[dir=rtl] .pr-21px {
  padding-right: 0;
  padding-left: 21px;
}
[dir=rtl] .pr-22px {
  padding-right: 0;
  padding-left: 22px;
}
[dir=rtl] .pr-23px {
  padding-right: 0;
  padding-left: 23px;
}
[dir=rtl] .pr-24px {
  padding-right: 0;
  padding-left: 24px;
}
[dir=rtl] .pr-25px {
  padding-right: 0;
  padding-left: 25px;
}
[dir=rtl] .pr-26px {
  padding-right: 0;
  padding-left: 26px;
}
[dir=rtl] .pr-27px {
  padding-right: 0;
  padding-left: 27px;
}
[dir=rtl] .pr-28px {
  padding-right: 0;
  padding-left: 28px;
}
[dir=rtl] .pr-29px {
  padding-right: 0;
  padding-left: 29px;
}
[dir=rtl] .pr-30px {
  padding-right: 0;
  padding-left: 30px;
}
[dir=rtl] .pr-35px {
  padding-right: 0;
  padding-left: 35px;
}
[dir=rtl] .pr-40px {
  padding-right: 0;
  padding-left: 40px;
}
[dir=rtl] .pr-45px {
  padding-right: 0;
  padding-left: 45px;
}
[dir=rtl] .pr-50px {
  padding-right: 0;
  padding-left: 50px;
}
[dir=rtl] .pr-55px {
  padding-right: 0;
  padding-left: 55px;
}
[dir=rtl] .pr-60px {
  padding-right: 0;
  padding-left: 60px;
}
[dir=rtl] .pl-5px {
  padding-left: 0;
  padding-right: 5px;
}
[dir=rtl] .pl-6px {
  padding-left: 0;
  padding-right: 6px;
}
[dir=rtl] .pl-7px {
  padding-left: 0;
  padding-right: 7px;
}
[dir=rtl] .pl-8px {
  padding-left: 0;
  padding-right: 8px;
}
[dir=rtl] .pl-9px {
  padding-left: 0;
  padding-right: 9px;
}
[dir=rtl] .pl-10px {
  padding-left: 0;
  padding-right: 10px;
}
[dir=rtl] .pl-11px {
  padding-left: 0;
  padding-right: 11px;
}
[dir=rtl] .pl-12px {
  padding-left: 0;
  padding-right: 12px;
}
[dir=rtl] .pl-13px {
  padding-left: 0;
  padding-right: 13px;
}
[dir=rtl] .pl-14px {
  padding-left: 0;
  padding-right: 14px;
}
[dir=rtl] .pl-15px {
  padding-left: 0;
  padding-right: 15px;
}
[dir=rtl] .pl-16px {
  padding-left: 0;
  padding-right: 16px;
}
[dir=rtl] .pl-17px {
  padding-left: 0;
  padding-right: 17px;
}
[dir=rtl] .pl-18px {
  padding-left: 0;
  padding-right: 18px;
}
[dir=rtl] .pl-19px {
  padding-left: 0;
  padding-right: 19px;
}
[dir=rtl] .pl-20px {
  padding-left: 0;
  padding-right: 20px;
}
[dir=rtl] .pl-21px {
  padding-left: 0;
  padding-right: 21px;
}
[dir=rtl] .pl-22px {
  padding-left: 0;
  padding-right: 22px;
}
[dir=rtl] .pl-23px {
  padding-left: 0;
  padding-right: 23px;
}
[dir=rtl] .pl-24px {
  padding-left: 0;
  padding-right: 24px;
}
[dir=rtl] .pl-25px {
  padding-left: 0;
  padding-right: 25px;
}
[dir=rtl] .pl-26px {
  padding-left: 0;
  padding-right: 26px;
}
[dir=rtl] .pl-27px {
  padding-left: 0;
  padding-right: 27px;
}
[dir=rtl] .pl-28px {
  padding-left: 0;
  padding-right: 28px;
}
[dir=rtl] .pl-29px {
  padding-left: 0;
  padding-right: 29px;
}
[dir=rtl] .pl-30px {
  padding-left: 0;
  padding-right: 30px;
}
[dir=rtl] .pl-35px {
  padding-left: 0;
  padding-right: 35px;
}
[dir=rtl] .pl-40px {
  padding-left: 0;
  padding-right: 40px;
}
[dir=rtl] .pl-45px {
  padding-left: 0;
  padding-right: 45px;
}
[dir=rtl] .pl-50px {
  padding-left: 0;
  padding-right: 50px;
}
[dir=rtl] .pl-55px {
  padding-left: 0;
  padding-right: 55px;
}
[dir=rtl] .pl-60px {
  padding-left: 0;
  padding-right: 60px;
}
[dir=rtl] .right-5px {
  right: auto;
  left: 5px;
}
[dir=rtl] .right-6px {
  right: auto;
  left: 6px;
}
[dir=rtl] .right-7px {
  right: auto;
  left: 7px;
}
[dir=rtl] .right-8px {
  right: auto;
  left: 8px;
}
[dir=rtl] .right-9px {
  right: auto;
  left: 9px;
}
[dir=rtl] .right-10px {
  right: auto;
  left: 10px;
}
[dir=rtl] .right-11px {
  right: auto;
  left: 11px;
}
[dir=rtl] .right-12px {
  right: auto;
  left: 12px;
}
[dir=rtl] .right-13px {
  right: auto;
  left: 13px;
}
[dir=rtl] .right-14px {
  right: auto;
  left: 14px;
}
[dir=rtl] .right-15px {
  right: auto;
  left: 15px;
}
[dir=rtl] .right-16px {
  right: auto;
  left: 16px;
}
[dir=rtl] .right-17px {
  right: auto;
  left: 17px;
}
[dir=rtl] .right-18px {
  right: auto;
  left: 18px;
}
[dir=rtl] .right-19px {
  right: auto;
  left: 19px;
}
[dir=rtl] .right-20px {
  right: auto;
  left: 20px;
}
[dir=rtl] .right-21px {
  right: auto;
  left: 21px;
}
[dir=rtl] .right-22px {
  right: auto;
  left: 22px;
}
[dir=rtl] .right-23px {
  right: auto;
  left: 23px;
}
[dir=rtl] .right-24px {
  right: auto;
  left: 24px;
}
[dir=rtl] .right-25px {
  right: auto;
  left: 25px;
}
[dir=rtl] .right-26px {
  right: auto;
  left: 27px;
}
[dir=rtl] .right-28px {
  right: auto;
  left: 28px;
}
[dir=rtl] .right-29px {
  right: auto;
  left: 29px;
}
[dir=rtl] .right-30px {
  right: auto;
  left: 30px;
}
[dir=rtl] .search-form {
  margin-right: 20px;
  margin-left: 0;
}
[dir=rtl] .LeftSidebarNav {
  left: auto;
  right: 0;
}
[dir=rtl] .main-wrapper-content {
  padding-left: 0;
  padding-right: 330px;
}
[dir=rtl] .main-wrapper-content .main-content {
  padding-right: 0;
  padding-left: 30px;
}
[dir=rtl] .main-wrapper-content.active {
  padding-right: 30px;
}
[dir=rtl] .main-wrapper-content.active .LeftSidebarNav {
  left: auto;
  right: -100%;
}
@media only screen and (max-width: 767px) {
  [dir=rtl] .main-wrapper-content .main-content {
    padding-left: 15px !important;
    padding-right: 15px !important;
  }
}
@media only screen and (max-width: 1199px) {
  [dir=rtl] .main-wrapper-content {
    padding: 0;
  }
  [dir=rtl] .main-wrapper-content .LeftSidebarNav {
    left: auto;
    right: -100%;
    width: 280px;
  }
  [dir=rtl] .main-wrapper-content .main-content {
    padding-left: 30px;
    padding-right: 30px;
  }
  [dir=rtl] .main-wrapper-content.active {
    padding: 0;
  }
  [dir=rtl] .main-wrapper-content.active .LeftSidebarNav {
    left: auto;
    right: 0;
  }
}
[dir=rtl] .apexcharts-legend-marker {
  margin-right: 0;
  margin-left: 3px;
}
[dir=rtl] .apexcharts-yaxis, [dir=rtl] .apexcharts-subtitle-text, [dir=rtl] .apexcharts-title-text {
  direction: ltr;
}
[dir=rtl] .css-1qlw4ct-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper:before, [dir=rtl] .css-1mpld98-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper:before {
  display: none;
}
[dir=rtl] .recharts-legend-item .recharts-surface {
  margin-right: 0;
  margin-left: 4px;
}
[dir=rtl] .ls-search-form input.MuiInputBase-input {
  padding-right: 15px;
}
[dir=rtl] .ls-search-form .search-btn {
  right: auto;
  left: 0;
}
[dir=rtl] .css-s2uf1z {
  text-align: left;
}
[dir=rtl] .MuiAlert-icon {
  margin-right: 0;
  margin-left: 12px;
}
[dir=rtl] .input-label label {
  left: auto;
  right: 0;
  transform: translate(-15px, 16px) scale(1);
}
[dir=rtl] .css-b1hphm-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon {
  margin-right: 0;
  margin-left: 10px;
}
[dir=rtl] .avatars-gap .MuiAvatar-root {
  margin-left: 16px;
}
[dir=rtl] .avatars-gap .MuiAvatar-root:last-child {
  margin-left: 0;
}
[dir=rtl] .gadge-gap .MuiBadge-root {
  margin-left: 16px;
}
[dir=rtl] .gadge-gap .MuiBadge-root:last-child {
  margin-left: 0;
}
[dir=rtl] .MuiButtonBase-root .MuiButton-startIcon {
  margin-right: 0;
  margin-left: 8px;
}
[dir=rtl] .MuiAlert-root .css-ki1hdl-MuiAlert-action {
  margin-left: -8px;
  margin-right: auto;
}
[dir=rtl] .chip-gap-for-rtl .MuiChip-root {
  margin-left: 0;
  margin-right: 15px;
}
[dir=rtl] .chip-gap-for-rtl .MuiChip-root:first-child {
  margin-right: 0;
}
[dir=rtl] .direction-ltr {
  direction: ltr;
}
[dir=rtl] .rtl-step-label .MuiStepLabel-iconContainer {
  padding-right: 0;
  padding-left: 10px;
}
[dir=rtl] .scroll-to-top i {
  right: auto;
  left: 20px;
}
[dir=rtl] .control-panel-modal {
  right: auto;
  left: -100%;
}
[dir=rtl] .control-panel-modal.show {
  right: auto;
  left: 0;
}
[dir=rtl] .control-panel-modal .settings-btn {
  right: auto;
  left: 15px;
}
[dir=rtl] .control-panel-dialog {
  margin-left: 0;
  margin-right: auto;
}`, "",{"version":3,"sources":["webpack://./src/styles/rtl.scss","webpack://./src/styles/rtl.css"],"names":[],"mappings":"AAEE;EACE,iBAAA;ACDJ;ADKE;EACE,cAAA;EACA,YAAA;ACHJ;ADKE;EACE,cAAA;EACA,WAAA;ACHJ;ADOE;EACE,yBAAA;EACA,6BAAA;ACLJ;ADOE;EACE,yBAAA;EACA,4BAAA;ACLJ;ADOE;EACE,yBAAA;EACA,6BAAA;ACLJ;ADOE;EACE,yBAAA;EACA,6BAAA;ACLJ;ADOE;EACE,yBAAA;EACA,6BAAA;ACLJ;ADOE;EACE,yBAAA;EACA,6BAAA;ACLJ;ADSE;EACE,0BAAA;EACA,2BAAA;ACPJ;ADSE;EACE,0BAAA;EACA,4BAAA;ACPJ;ADSE;EACE,0BAAA;EACA,4BAAA;ACPJ;ADSE;EACE,0BAAA;EACA,4BAAA;ACPJ;ADSE;EACE,0BAAA;EACA,4BAAA;ACPJ;ADWE;EACE,yBAAA;EACA,4BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,4BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,4BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,4BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,4BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADWE;EACE,yBAAA;EACA,6BAAA;ACTJ;ADaE;EACE,0BAAA;EACA,2BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,2BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,2BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,2BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,2BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADaE;EACE,0BAAA;EACA,4BAAA;ACXJ;ADeE;EACE,gBAAA;EACA,iBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,iBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,iBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,iBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,iBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADeE;EACE,gBAAA;EACA,kBAAA;ACbJ;ADiBE;EACE,eAAA;EACA,kBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,kBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,kBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,kBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,kBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADiBE;EACE,eAAA;EACA,mBAAA;ACfJ;ADmBE;EACE,WAAA;EACA,SAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,SAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,SAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,SAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,SAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADmBE;EACE,WAAA;EACA,UAAA;ACjBJ;ADqBE;EACE,kBAAA;EACA,cAAA;ACnBJ;ADuBE;EACE,UAAA;EACA,QAAA;ACrBJ;ADyBE;EACE,eAAA;EACA,oBAAA;ACvBJ;ADwBI;EACE,gBAAA;EACA,kBAAA;ACtBN;ADwBI;EACE,mBAAA;ACtBN;ADuBM;EACE,UAAA;EACA,YAAA;ACrBR;AD0BE;EAEI;IACE,6BAAA;IACA,8BAAA;ECzBN;AACF;AD6BE;EACE;IACE,UAAA;EC3BJ;ED6BI;IACE,UAAA;IACA,YAAA;IACA,YAAA;EC3BN;ED6BI;IACE,kBAAA;IACA,mBAAA;EC3BN;ED8BI;IACE,UAAA;EC5BN;ED8BM;IACE,UAAA;IACA,QAAA;EC5BR;AACF;ADkCE;EACE,eAAA;EACA,gBAAA;AChCJ;ADkCE;EACE,cAAA;AChCJ;ADoCI;EACE,aAAA;AClCN;ADuCI;EACE,eAAA;EACA,gBAAA;ACrCN;AD2CI;EACE,mBAAA;ACzCN;AD2CI;EACE,WAAA;EACA,OAAA;ACzCN;AD6CE;EACE,gBAAA;AC3CJ;AD8CE;EACE,eAAA;EACA,iBAAA;AC5CJ;ADgDI;EACE,UAAA;EACA,QAAA;EACA,0CAAA;AC9CN;ADkDE;EACE,eAAA;EACA,iBAAA;AChDJ;ADoDI;EACE,iBAAA;AClDN;ADmDM;EACE,cAAA;ACjDR;ADsDI;EACE,iBAAA;ACpDN;ADqDM;EACE,cAAA;ACnDR;ADyDI;EACE,eAAA;EACA,gBAAA;ACvDN;AD2DI;EACE,iBAAA;EACA,kBAAA;ACzDN;AD6DI;EACE,cAAA;EACA,kBAAA;AC3DN;AD4DM;EACE,eAAA;AC1DR;AD+DE;EACE,cAAA;AC7DJ;AD+DE;EACE,gBAAA;EACA,kBAAA;AC7DJ;ADkEI;EACE,WAAA;EACA,UAAA;AChEN;ADqEE;EACE,WAAA;EACA,WAAA;ACnEJ;ADqEI;EACE,WAAA;EACA,OAAA;ACnEN;ADsEI;EACE,WAAA;EACA,UAAA;ACpEN;ADuEE;EACE,cAAA;EACA,kBAAA;ACrEJ","sourcesContent":["[dir=\"rtl\"] {\n\n  table, th, tr, td {\n    text-align: right;\n  }\n\n  // Float\n  .float-left {\n    float: initial;\n    float: right;\n  }\n  .float-right {\n    float: initial;\n    float: left;\n  }\n  \n  // Margin Left\n  .ml-auto {\n    margin-left: 0 !important;\n    margin-right: auto !important;\n  }\n  .ml-1 {\n    margin-left: 0 !important;\n    margin-right: 8px !important;\n  }\n  .ml-2 {\n    margin-left: 0 !important;\n    margin-right: 16px !important;\n  }\n  .ml-3 {\n    margin-left: 0 !important;\n    margin-right: 24px !important;\n  }\n  .ml-4 {\n    margin-left: 0 !important;\n    margin-right: 32px !important;\n  }\n  .ml-5 {\n    margin-left: 0 !important;\n    margin-right: 40px !important;\n  }\n  \n  // Margin Right\n  .mr-1 {\n    margin-right: 0 !important;\n    margin-left: 8px !important;\n  }\n  .mr-2 {\n    margin-right: 0 !important;\n    margin-left: 16px !important;\n  }\n  .mr-3 {\n    margin-right: 0 !important;\n    margin-left: 24px !important;\n  }\n  .mr-4 {\n    margin-right: 0 !important;\n    margin-left: 32px !important;\n  }\n  .mr-5 {\n    margin-right: 0 !important;\n    margin-left: 40px !important; \n  }\n  \n  // Margin Left\n  .ml-5px {\n    margin-left: 0 !important;\n    margin-right: 5px !important;\n  }\n  .ml-6px {\n    margin-left: 0 !important;\n    margin-right: 6px !important;\n  }\n  .ml-7px {\n    margin-left: 0 !important;\n    margin-right: 7px !important;\n  }\n  .ml-8px {\n    margin-left: 0 !important;\n    margin-right: 8px !important;\n  }\n  .ml-9px {\n    margin-left: 0 !important;\n    margin-right: 9px !important;\n  }\n  .ml-10px {\n    margin-left: 0 !important;\n    margin-right: 10px !important;\n  }\n  .ml-11px {\n    margin-left: 0 !important;\n    margin-right: 11px !important;\n  }\n  .ml-12px {\n    margin-left: 0 !important;\n    margin-right: 12px !important;\n  }\n  .ml-13px {\n    margin-left: 0 !important;\n    margin-right: 13px !important;\n  }\n  .ml-14px {\n    margin-left: 0 !important;\n    margin-right: 14px !important;\n  }\n  .ml-15px {\n    margin-left: 0 !important;\n    margin-right: 15px !important;\n  }\n  .ml-16px {\n    margin-left: 0 !important;\n    margin-right: 16px !important;\n  }\n  .ml-17px {\n    margin-left: 0 !important;\n    margin-right: 17px !important;\n  }\n  .ml-18px {\n    margin-left: 0 !important;\n    margin-right: 18px !important;\n  }\n  .ml-19px {\n    margin-left: 0 !important;\n    margin-right: 19px !important;\n  }\n  .ml-20px {\n    margin-left: 0 !important;\n    margin-right: 20px !important;\n  }\n  .ml-21px {\n    margin-left: 0 !important;\n    margin-right: 21px !important;\n  }\n  .ml-22px {\n    margin-left: 0 !important;\n    margin-right: 22px !important;\n  }\n  .ml-23px {\n    margin-left: 0 !important;\n    margin-right: 23px !important;\n  }\n  .ml-24px {\n    margin-left: 0 !important;\n    margin-right: 24px !important;\n  }\n  .ml-25px {\n    margin-left: 0 !important;\n    margin-right: 25px !important;\n  }\n  .ml-26px {\n    margin-left: 0 !important;\n    margin-right: 26px !important;\n  }\n  .ml-27px {\n    margin-left: 0 !important;\n    margin-right: 27px !important;\n  }\n  .ml-28px {\n    margin-left: 0 !important;\n    margin-right: 28px !important;\n  }\n  .ml-29px {\n    margin-left: 0 !important;\n    margin-right: 29px !important;\n  }\n  .ml-30px {\n    margin-left: 0 !important;\n    margin-right: 30px !important;\n  }\n\n  // Margin Right\n  .mr-5px {\n    margin-right: 0 !important;\n    margin-left: 5px !important;\n  }\n  .mr-6px {\n    margin-right: 0 !important; \n    margin-left: 6px !important;\n  }\n  .mr-7px {\n    margin-right: 0 !important;\n    margin-left: 7px !important;\n  }\n  .ml-8px {\n    margin-right: 0 !important;\n    margin-left: 8px !important;\n  }\n  .mr-9px {\n    margin-right: 0 !important;\n    margin-left: 9px !important;\n  }\n  .mr-10px {\n    margin-right: 0 !important;\n    margin-left: 10px !important;\n  }\n  .mr-11px {\n    margin-right: 0 !important;\n    margin-left: 11px !important;\n  }\n  .mr-12px {\n    margin-right: 0 !important;\n    margin-left: 12px !important;\n  }\n  .mr-13px {\n    margin-right: 0 !important;\n    margin-left: 13px !important;\n  }\n  .mr-14px {\n    margin-right: 0 !important;\n    margin-left: 14px !important;\n  }\n  .mr-15px {\n    margin-right: 0 !important;\n    margin-left: 15px !important;\n  }\n  .mr-16px {\n    margin-right: 0 !important;\n    margin-left: 16px !important;\n  }\n  .mr-17px {\n    margin-right: 0 !important;\n    margin-left: 17px !important;\n  }\n  .mr-18px {\n    margin-right: 0 !important;\n    margin-left: 18px !important;\n  }\n  .mr-19px {\n    margin-right: 0 !important;\n    margin-left: 19px !important;\n  }\n  .mr-20px {\n    margin-right: 0 !important;\n    margin-left: 20px !important;\n  }\n  .mr-21px {\n    margin-right: 0 !important;\n    margin-left: 21px !important;\n  }\n  .mr-22px {\n    margin-right: 0 !important;\n    margin-left: 22px !important;\n  }\n  .mr-23px {\n    margin-right: 0 !important;\n    margin-left: 23px !important;\n  }\n  .mr-24px {\n    margin-right: 0 !important;\n    margin-left: 24px !important;\n  }\n  .mr-25px {\n    margin-right: 0 !important;\n    margin-left: 25px !important;\n  }\n  .mr-26px {\n    margin-right: 0 !important;\n    margin-left: 26px !important;\n  }\n  .mr-27px {\n    margin-right: 0 !important;\n    margin-left: 27px !important;\n  }\n  .mr-28px {\n    margin-right: 0 !important;\n    margin-left: 28px !important;\n  }\n  .mr-29px {\n    margin-right: 0 !important;\n    margin-left: 29px !important;\n  }\n  .mr-30px {\n    margin-right: 0 !important;\n    margin-left: 30px !important;\n  }\n\n  // Padding Right\n  .pr-5px {\n    padding-right: 0;\n    padding-left: 5px;\n  }\n  .pr-6px {\n    padding-right: 0;\n    padding-left: 6px;\n  }\n  .pr-7px {\n    padding-right: 0;\n    padding-left: 7px;\n  }\n  .pr-8px {\n    padding-right: 0;\n    padding-left: 8px;\n  }\n  .pr-9px {\n    padding-right: 0;\n    padding-left: 9px;\n  }\n  .pr-10px {\n    padding-right: 0;\n    padding-left: 10px;\n  }\n  .pr-11px {\n    padding-right: 0;\n    padding-left: 11px;\n  }\n  .pr-12px {\n    padding-right: 0;\n    padding-left: 12px;\n  }\n  .pr-13px {\n    padding-right: 0;\n    padding-left: 13px;\n  }\n  .pr-14px {\n    padding-right: 0;\n    padding-left: 14px;\n  }\n  .pr-15px {\n    padding-right: 0;\n    padding-left: 15px;\n  }\n  .pr-16px {\n    padding-right: 0;\n    padding-left: 16px;\n  }\n  .pr-17px {\n    padding-right: 0;\n    padding-left: 17px;\n  }\n  .pr-18px {\n    padding-right: 0;\n    padding-left: 18px;\n  }\n  .pr-19px {\n    padding-right: 0;\n    padding-left: 19px;\n  }\n  .pr-20px {\n    padding-right: 0;\n    padding-left: 20px;\n  }\n  .pr-21px {\n    padding-right: 0;\n    padding-left: 21px;\n  }\n  .pr-22px {\n    padding-right: 0;\n    padding-left: 22px;\n  }\n  .pr-23px {\n    padding-right: 0;\n    padding-left: 23px;\n  }\n  .pr-24px {\n    padding-right: 0;\n    padding-left: 24px;\n  }\n  .pr-25px {\n    padding-right: 0;\n    padding-left: 25px;\n  }\n  .pr-26px {\n    padding-right: 0;\n    padding-left: 26px;\n  }\n  .pr-27px {\n    padding-right: 0;\n    padding-left: 27px;\n  }\n  .pr-28px {\n    padding-right: 0;\n    padding-left: 28px;\n  }\n  .pr-29px {\n    padding-right: 0;\n    padding-left: 29px;\n  }\n  .pr-30px {\n    padding-right: 0;\n    padding-left: 30px;\n  }\n  .pr-35px {\n    padding-right: 0;\n    padding-left: 35px;\n  }\n  .pr-40px {\n    padding-right: 0;\n    padding-left: 40px;\n  }\n  .pr-45px {\n    padding-right: 0;\n    padding-left: 45px;\n  }\n  .pr-50px {\n    padding-right: 0;\n    padding-left: 50px;\n  }\n  .pr-55px {\n    padding-right: 0;\n    padding-left: 55px;\n  }\n  .pr-60px {\n    padding-right: 0;\n    padding-left: 60px;\n  } \n\n  // Padding Left\n  .pl-5px {\n    padding-left: 0;\n    padding-right: 5px;\n  }\n  .pl-6px {\n    padding-left: 0;\n    padding-right: 6px;\n  }\n  .pl-7px {\n    padding-left: 0;\n    padding-right: 7px;\n  }\n  .pl-8px {\n    padding-left: 0;\n    padding-right: 8px;\n  }\n  .pl-9px {\n    padding-left: 0;\n    padding-right: 9px;\n  }\n  .pl-10px {\n    padding-left: 0;\n    padding-right: 10px;\n  }\n  .pl-11px {\n    padding-left: 0;\n    padding-right: 11px;\n  }\n  .pl-12px {\n    padding-left: 0;\n    padding-right: 12px;\n  }\n  .pl-13px {\n    padding-left: 0;\n    padding-right: 13px;\n  }\n  .pl-14px {\n    padding-left: 0;\n    padding-right: 14px;\n  }\n  .pl-15px {\n    padding-left: 0;\n    padding-right: 15px;\n  }\n  .pl-16px {\n    padding-left: 0;\n    padding-right: 16px;\n  }\n  .pl-17px {\n    padding-left: 0;\n    padding-right: 17px;\n  }\n  .pl-18px {\n    padding-left: 0;\n    padding-right: 18px;\n  }\n  .pl-19px {\n    padding-left: 0;\n    padding-right: 19px;\n  }\n  .pl-20px {\n    padding-left: 0;\n    padding-right: 20px;\n  }\n  .pl-21px {\n    padding-left: 0;\n    padding-right: 21px;\n  }\n  .pl-22px {\n    padding-left: 0;\n    padding-right: 22px;\n  }\n  .pl-23px {\n    padding-left: 0;\n    padding-right: 23px;\n  }\n  .pl-24px {\n    padding-left: 0;\n    padding-right: 24px;\n  }\n  .pl-25px {\n    padding-left: 0;\n    padding-right: 25px;\n  }\n  .pl-26px {\n    padding-left: 0;\n    padding-right: 26px;\n  }\n  .pl-27px {\n    padding-left: 0;\n    padding-right: 27px;\n  }\n  .pl-28px {\n    padding-left: 0;\n    padding-right: 28px;\n  }\n  .pl-29px {\n    padding-left: 0;\n    padding-right: 29px;\n  }\n  .pl-30px {\n    padding-left: 0;\n    padding-right: 30px;\n  }\n  .pl-35px {\n    padding-left: 0;\n    padding-right: 35px;\n  }\n  .pl-40px {\n    padding-left: 0;\n    padding-right: 40px;\n  }\n  .pl-45px {\n    padding-left: 0;\n    padding-right: 45px;\n  }\n  .pl-50px {\n    padding-left: 0;\n    padding-right: 50px;\n  }\n  .pl-55px {\n    padding-left: 0;\n    padding-right: 55px;\n  }\n  .pl-60px {\n    padding-left: 0;\n    padding-right: 60px;\n  }\n\n  // Right\n  .right-5px {\n    right: auto;\n    left: 5px;\n  }\n  .right-6px {\n    right: auto;\n    left: 6px;\n  }\n  .right-7px {\n    right: auto;\n    left: 7px;\n  }\n  .right-8px {\n    right: auto;\n    left: 8px;\n  }\n  .right-9px {\n    right: auto;\n    left: 9px;\n  }\n  .right-10px {\n    right: auto;\n    left: 10px;\n  }\n  .right-11px {\n    right: auto;\n    left: 11px;\n  }\n  .right-12px {\n    right: auto;\n    left: 12px;\n  }\n  .right-13px {\n    right: auto;\n    left: 13px;\n  }\n  .right-14px {\n    right: auto;\n    left: 14px;\n  }\n  .right-15px {\n    right: auto;\n    left: 15px;\n  }\n  .right-16px {\n    right: auto;\n    left: 16px;\n  }\n  .right-17px {\n    right: auto;\n    left: 17px;\n  }\n  .right-18px {\n    right: auto;\n    left: 18px;\n  }\n  .right-19px {\n    right: auto;\n    left: 19px;\n  }\n  .right-20px {\n    right: auto;\n    left: 20px;\n  }\n  .right-21px {\n    right: auto;\n    left: 21px;\n  }\n  .right-22px {\n    right: auto;\n    left: 22px;\n  }\n  .right-23px {\n    right: auto;\n    left: 23px;\n  }\n  .right-24px {\n    right: auto;\n    left: 24px;\n  }\n  .right-25px {\n    right: auto;\n    left: 25px;\n  }\n  .right-26px {\n    right: auto;\n    left: 27px;\n  }\n  .right-28px {\n    right: auto;\n    left: 28px;\n  }\n  .right-29px {\n    right: auto;\n    left: 29px;\n  }\n  .right-30px {\n    right: auto;\n    left: 30px;\n  }\n\n  // Top Navbar\n  .search-form {\n    margin-right: 20px;\n    margin-left: 0;\n  }\n\n  // LeftSidebarNav\n  .LeftSidebarNav {\n    left: auto;\n    right: 0;\n  }\n\n  // main-wrapper-content\n  .main-wrapper-content {\n    padding-left: 0;\n    padding-right: 330px;\n    .main-content {\n      padding-right: 0;\n      padding-left: 30px;\n    }\n    &.active {\n      padding-right: 30px;\n      .LeftSidebarNav {\n        left: auto;\n        right: -100%;\n      }\n    }\n  }\n\n  @media only screen and (max-width: 767px) {\n    .main-wrapper-content {\n      .main-content {\n        padding-left: 15px !important;\n        padding-right: 15px !important;\n      }\n    }\n  }\n  \n  @media only screen and (max-width: 1199px) {\n    .main-wrapper-content {\n      padding: 0;\n   \n      .LeftSidebarNav { \n        left: auto;\n        right: -100%;\n        width: 280px;\n      }\n      .main-content {\n        padding-left: 30px;\n        padding-right: 30px;\n      }\n  \n      &.active {\n        padding: 0;\n\n        .LeftSidebarNav {\n          left: auto;\n          right: 0;\n        }\n      }\n    }\n  }\n\n  // apexcharts\n  .apexcharts-legend-marker {\n    margin-right: 0;\n    margin-left: 3px;\n  }\n  .apexcharts-yaxis, .apexcharts-subtitle-text, .apexcharts-title-text {\n    direction: ltr;\n  }\n  \n  .css-1qlw4ct-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper, .css-1mpld98-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper{\n    &:before {\n      display: none;\n    }\n  }\n\n  .recharts-legend-item {\n    .recharts-surface {\n      margin-right: 0;\n      margin-left: 4px;\n    }\n  }\n\n  // ls-search-form\n  .ls-search-form {\n    input.MuiInputBase-input {\n      padding-right: 15px;\n    }\n    .search-btn {\n      right: auto;\n      left: 0;\n    }\n  }\n\n  .css-s2uf1z {\n    text-align: left;\n  }\n\n  .MuiAlert-icon  {\n    margin-right: 0;\n    margin-left: 12px;\n  }\n  \n  .input-label {\n    label {\n      left: auto;\n      right: 0;\n      transform: translate(-15px, 16px) scale(1);\n    }\n  }\n\n  .css-b1hphm-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon {\n    margin-right: 0;\n    margin-left: 10px;\n  }\n\n  .avatars-gap {\n    .MuiAvatar-root {\n      margin-left: 16px;\n      &:last-child {\n        margin-left: 0;\n      }\n    }\n  }\n  .gadge-gap {\n    .MuiBadge-root {\n      margin-left: 16px;\n      &:last-child {\n        margin-left: 0;\n      }\n    }\n  }\n\n  .MuiButtonBase-root {\n    .MuiButton-startIcon {\n      margin-right: 0;\n      margin-left: 8px;\n    }\n  }\n  .MuiAlert-root {\n    .css-ki1hdl-MuiAlert-action {\n      margin-left: -8px;\n      margin-right: auto;\n    }\n  }\n  .chip-gap-for-rtl {\n    .MuiChip-root {\n      margin-left: 0;\n      margin-right: 15px;\n      &:first-child {\n        margin-right: 0;\n      }\n    }\n  }\n\n  .direction-ltr {\n    direction: ltr;\n  }\n  .rtl-step-label .MuiStepLabel-iconContainer {\n    padding-right: 0;\n    padding-left: 10px; \n  }\n  \n  // Scroll To Top CSS\n  .scroll-to-top {\n    i {\n      right: auto;\n      left: 20px;\n    }\n  }\n\n  // control-panel-modal\n  .control-panel-modal {\n    right: auto;\n    left: -100%;\n\n    &.show {\n      right: auto;\n      left: 0;\n    }\n\n    .settings-btn {\n      right: auto;\n      left: 15px;\n    }\n  }\n  .control-panel-dialog {\n    margin-left: 0;\n    margin-right: auto;\n  }\n \n}\n\n","[dir=rtl] table, [dir=rtl] th, [dir=rtl] tr, [dir=rtl] td {\n  text-align: right;\n}\n[dir=rtl] .float-left {\n  float: initial;\n  float: right;\n}\n[dir=rtl] .float-right {\n  float: initial;\n  float: left;\n}\n[dir=rtl] .ml-auto {\n  margin-left: 0 !important;\n  margin-right: auto !important;\n}\n[dir=rtl] .ml-1 {\n  margin-left: 0 !important;\n  margin-right: 8px !important;\n}\n[dir=rtl] .ml-2 {\n  margin-left: 0 !important;\n  margin-right: 16px !important;\n}\n[dir=rtl] .ml-3 {\n  margin-left: 0 !important;\n  margin-right: 24px !important;\n}\n[dir=rtl] .ml-4 {\n  margin-left: 0 !important;\n  margin-right: 32px !important;\n}\n[dir=rtl] .ml-5 {\n  margin-left: 0 !important;\n  margin-right: 40px !important;\n}\n[dir=rtl] .mr-1 {\n  margin-right: 0 !important;\n  margin-left: 8px !important;\n}\n[dir=rtl] .mr-2 {\n  margin-right: 0 !important;\n  margin-left: 16px !important;\n}\n[dir=rtl] .mr-3 {\n  margin-right: 0 !important;\n  margin-left: 24px !important;\n}\n[dir=rtl] .mr-4 {\n  margin-right: 0 !important;\n  margin-left: 32px !important;\n}\n[dir=rtl] .mr-5 {\n  margin-right: 0 !important;\n  margin-left: 40px !important;\n}\n[dir=rtl] .ml-5px {\n  margin-left: 0 !important;\n  margin-right: 5px !important;\n}\n[dir=rtl] .ml-6px {\n  margin-left: 0 !important;\n  margin-right: 6px !important;\n}\n[dir=rtl] .ml-7px {\n  margin-left: 0 !important;\n  margin-right: 7px !important;\n}\n[dir=rtl] .ml-8px {\n  margin-left: 0 !important;\n  margin-right: 8px !important;\n}\n[dir=rtl] .ml-9px {\n  margin-left: 0 !important;\n  margin-right: 9px !important;\n}\n[dir=rtl] .ml-10px {\n  margin-left: 0 !important;\n  margin-right: 10px !important;\n}\n[dir=rtl] .ml-11px {\n  margin-left: 0 !important;\n  margin-right: 11px !important;\n}\n[dir=rtl] .ml-12px {\n  margin-left: 0 !important;\n  margin-right: 12px !important;\n}\n[dir=rtl] .ml-13px {\n  margin-left: 0 !important;\n  margin-right: 13px !important;\n}\n[dir=rtl] .ml-14px {\n  margin-left: 0 !important;\n  margin-right: 14px !important;\n}\n[dir=rtl] .ml-15px {\n  margin-left: 0 !important;\n  margin-right: 15px !important;\n}\n[dir=rtl] .ml-16px {\n  margin-left: 0 !important;\n  margin-right: 16px !important;\n}\n[dir=rtl] .ml-17px {\n  margin-left: 0 !important;\n  margin-right: 17px !important;\n}\n[dir=rtl] .ml-18px {\n  margin-left: 0 !important;\n  margin-right: 18px !important;\n}\n[dir=rtl] .ml-19px {\n  margin-left: 0 !important;\n  margin-right: 19px !important;\n}\n[dir=rtl] .ml-20px {\n  margin-left: 0 !important;\n  margin-right: 20px !important;\n}\n[dir=rtl] .ml-21px {\n  margin-left: 0 !important;\n  margin-right: 21px !important;\n}\n[dir=rtl] .ml-22px {\n  margin-left: 0 !important;\n  margin-right: 22px !important;\n}\n[dir=rtl] .ml-23px {\n  margin-left: 0 !important;\n  margin-right: 23px !important;\n}\n[dir=rtl] .ml-24px {\n  margin-left: 0 !important;\n  margin-right: 24px !important;\n}\n[dir=rtl] .ml-25px {\n  margin-left: 0 !important;\n  margin-right: 25px !important;\n}\n[dir=rtl] .ml-26px {\n  margin-left: 0 !important;\n  margin-right: 26px !important;\n}\n[dir=rtl] .ml-27px {\n  margin-left: 0 !important;\n  margin-right: 27px !important;\n}\n[dir=rtl] .ml-28px {\n  margin-left: 0 !important;\n  margin-right: 28px !important;\n}\n[dir=rtl] .ml-29px {\n  margin-left: 0 !important;\n  margin-right: 29px !important;\n}\n[dir=rtl] .ml-30px {\n  margin-left: 0 !important;\n  margin-right: 30px !important;\n}\n[dir=rtl] .mr-5px {\n  margin-right: 0 !important;\n  margin-left: 5px !important;\n}\n[dir=rtl] .mr-6px {\n  margin-right: 0 !important;\n  margin-left: 6px !important;\n}\n[dir=rtl] .mr-7px {\n  margin-right: 0 !important;\n  margin-left: 7px !important;\n}\n[dir=rtl] .ml-8px {\n  margin-right: 0 !important;\n  margin-left: 8px !important;\n}\n[dir=rtl] .mr-9px {\n  margin-right: 0 !important;\n  margin-left: 9px !important;\n}\n[dir=rtl] .mr-10px {\n  margin-right: 0 !important;\n  margin-left: 10px !important;\n}\n[dir=rtl] .mr-11px {\n  margin-right: 0 !important;\n  margin-left: 11px !important;\n}\n[dir=rtl] .mr-12px {\n  margin-right: 0 !important;\n  margin-left: 12px !important;\n}\n[dir=rtl] .mr-13px {\n  margin-right: 0 !important;\n  margin-left: 13px !important;\n}\n[dir=rtl] .mr-14px {\n  margin-right: 0 !important;\n  margin-left: 14px !important;\n}\n[dir=rtl] .mr-15px {\n  margin-right: 0 !important;\n  margin-left: 15px !important;\n}\n[dir=rtl] .mr-16px {\n  margin-right: 0 !important;\n  margin-left: 16px !important;\n}\n[dir=rtl] .mr-17px {\n  margin-right: 0 !important;\n  margin-left: 17px !important;\n}\n[dir=rtl] .mr-18px {\n  margin-right: 0 !important;\n  margin-left: 18px !important;\n}\n[dir=rtl] .mr-19px {\n  margin-right: 0 !important;\n  margin-left: 19px !important;\n}\n[dir=rtl] .mr-20px {\n  margin-right: 0 !important;\n  margin-left: 20px !important;\n}\n[dir=rtl] .mr-21px {\n  margin-right: 0 !important;\n  margin-left: 21px !important;\n}\n[dir=rtl] .mr-22px {\n  margin-right: 0 !important;\n  margin-left: 22px !important;\n}\n[dir=rtl] .mr-23px {\n  margin-right: 0 !important;\n  margin-left: 23px !important;\n}\n[dir=rtl] .mr-24px {\n  margin-right: 0 !important;\n  margin-left: 24px !important;\n}\n[dir=rtl] .mr-25px {\n  margin-right: 0 !important;\n  margin-left: 25px !important;\n}\n[dir=rtl] .mr-26px {\n  margin-right: 0 !important;\n  margin-left: 26px !important;\n}\n[dir=rtl] .mr-27px {\n  margin-right: 0 !important;\n  margin-left: 27px !important;\n}\n[dir=rtl] .mr-28px {\n  margin-right: 0 !important;\n  margin-left: 28px !important;\n}\n[dir=rtl] .mr-29px {\n  margin-right: 0 !important;\n  margin-left: 29px !important;\n}\n[dir=rtl] .mr-30px {\n  margin-right: 0 !important;\n  margin-left: 30px !important;\n}\n[dir=rtl] .pr-5px {\n  padding-right: 0;\n  padding-left: 5px;\n}\n[dir=rtl] .pr-6px {\n  padding-right: 0;\n  padding-left: 6px;\n}\n[dir=rtl] .pr-7px {\n  padding-right: 0;\n  padding-left: 7px;\n}\n[dir=rtl] .pr-8px {\n  padding-right: 0;\n  padding-left: 8px;\n}\n[dir=rtl] .pr-9px {\n  padding-right: 0;\n  padding-left: 9px;\n}\n[dir=rtl] .pr-10px {\n  padding-right: 0;\n  padding-left: 10px;\n}\n[dir=rtl] .pr-11px {\n  padding-right: 0;\n  padding-left: 11px;\n}\n[dir=rtl] .pr-12px {\n  padding-right: 0;\n  padding-left: 12px;\n}\n[dir=rtl] .pr-13px {\n  padding-right: 0;\n  padding-left: 13px;\n}\n[dir=rtl] .pr-14px {\n  padding-right: 0;\n  padding-left: 14px;\n}\n[dir=rtl] .pr-15px {\n  padding-right: 0;\n  padding-left: 15px;\n}\n[dir=rtl] .pr-16px {\n  padding-right: 0;\n  padding-left: 16px;\n}\n[dir=rtl] .pr-17px {\n  padding-right: 0;\n  padding-left: 17px;\n}\n[dir=rtl] .pr-18px {\n  padding-right: 0;\n  padding-left: 18px;\n}\n[dir=rtl] .pr-19px {\n  padding-right: 0;\n  padding-left: 19px;\n}\n[dir=rtl] .pr-20px {\n  padding-right: 0;\n  padding-left: 20px;\n}\n[dir=rtl] .pr-21px {\n  padding-right: 0;\n  padding-left: 21px;\n}\n[dir=rtl] .pr-22px {\n  padding-right: 0;\n  padding-left: 22px;\n}\n[dir=rtl] .pr-23px {\n  padding-right: 0;\n  padding-left: 23px;\n}\n[dir=rtl] .pr-24px {\n  padding-right: 0;\n  padding-left: 24px;\n}\n[dir=rtl] .pr-25px {\n  padding-right: 0;\n  padding-left: 25px;\n}\n[dir=rtl] .pr-26px {\n  padding-right: 0;\n  padding-left: 26px;\n}\n[dir=rtl] .pr-27px {\n  padding-right: 0;\n  padding-left: 27px;\n}\n[dir=rtl] .pr-28px {\n  padding-right: 0;\n  padding-left: 28px;\n}\n[dir=rtl] .pr-29px {\n  padding-right: 0;\n  padding-left: 29px;\n}\n[dir=rtl] .pr-30px {\n  padding-right: 0;\n  padding-left: 30px;\n}\n[dir=rtl] .pr-35px {\n  padding-right: 0;\n  padding-left: 35px;\n}\n[dir=rtl] .pr-40px {\n  padding-right: 0;\n  padding-left: 40px;\n}\n[dir=rtl] .pr-45px {\n  padding-right: 0;\n  padding-left: 45px;\n}\n[dir=rtl] .pr-50px {\n  padding-right: 0;\n  padding-left: 50px;\n}\n[dir=rtl] .pr-55px {\n  padding-right: 0;\n  padding-left: 55px;\n}\n[dir=rtl] .pr-60px {\n  padding-right: 0;\n  padding-left: 60px;\n}\n[dir=rtl] .pl-5px {\n  padding-left: 0;\n  padding-right: 5px;\n}\n[dir=rtl] .pl-6px {\n  padding-left: 0;\n  padding-right: 6px;\n}\n[dir=rtl] .pl-7px {\n  padding-left: 0;\n  padding-right: 7px;\n}\n[dir=rtl] .pl-8px {\n  padding-left: 0;\n  padding-right: 8px;\n}\n[dir=rtl] .pl-9px {\n  padding-left: 0;\n  padding-right: 9px;\n}\n[dir=rtl] .pl-10px {\n  padding-left: 0;\n  padding-right: 10px;\n}\n[dir=rtl] .pl-11px {\n  padding-left: 0;\n  padding-right: 11px;\n}\n[dir=rtl] .pl-12px {\n  padding-left: 0;\n  padding-right: 12px;\n}\n[dir=rtl] .pl-13px {\n  padding-left: 0;\n  padding-right: 13px;\n}\n[dir=rtl] .pl-14px {\n  padding-left: 0;\n  padding-right: 14px;\n}\n[dir=rtl] .pl-15px {\n  padding-left: 0;\n  padding-right: 15px;\n}\n[dir=rtl] .pl-16px {\n  padding-left: 0;\n  padding-right: 16px;\n}\n[dir=rtl] .pl-17px {\n  padding-left: 0;\n  padding-right: 17px;\n}\n[dir=rtl] .pl-18px {\n  padding-left: 0;\n  padding-right: 18px;\n}\n[dir=rtl] .pl-19px {\n  padding-left: 0;\n  padding-right: 19px;\n}\n[dir=rtl] .pl-20px {\n  padding-left: 0;\n  padding-right: 20px;\n}\n[dir=rtl] .pl-21px {\n  padding-left: 0;\n  padding-right: 21px;\n}\n[dir=rtl] .pl-22px {\n  padding-left: 0;\n  padding-right: 22px;\n}\n[dir=rtl] .pl-23px {\n  padding-left: 0;\n  padding-right: 23px;\n}\n[dir=rtl] .pl-24px {\n  padding-left: 0;\n  padding-right: 24px;\n}\n[dir=rtl] .pl-25px {\n  padding-left: 0;\n  padding-right: 25px;\n}\n[dir=rtl] .pl-26px {\n  padding-left: 0;\n  padding-right: 26px;\n}\n[dir=rtl] .pl-27px {\n  padding-left: 0;\n  padding-right: 27px;\n}\n[dir=rtl] .pl-28px {\n  padding-left: 0;\n  padding-right: 28px;\n}\n[dir=rtl] .pl-29px {\n  padding-left: 0;\n  padding-right: 29px;\n}\n[dir=rtl] .pl-30px {\n  padding-left: 0;\n  padding-right: 30px;\n}\n[dir=rtl] .pl-35px {\n  padding-left: 0;\n  padding-right: 35px;\n}\n[dir=rtl] .pl-40px {\n  padding-left: 0;\n  padding-right: 40px;\n}\n[dir=rtl] .pl-45px {\n  padding-left: 0;\n  padding-right: 45px;\n}\n[dir=rtl] .pl-50px {\n  padding-left: 0;\n  padding-right: 50px;\n}\n[dir=rtl] .pl-55px {\n  padding-left: 0;\n  padding-right: 55px;\n}\n[dir=rtl] .pl-60px {\n  padding-left: 0;\n  padding-right: 60px;\n}\n[dir=rtl] .right-5px {\n  right: auto;\n  left: 5px;\n}\n[dir=rtl] .right-6px {\n  right: auto;\n  left: 6px;\n}\n[dir=rtl] .right-7px {\n  right: auto;\n  left: 7px;\n}\n[dir=rtl] .right-8px {\n  right: auto;\n  left: 8px;\n}\n[dir=rtl] .right-9px {\n  right: auto;\n  left: 9px;\n}\n[dir=rtl] .right-10px {\n  right: auto;\n  left: 10px;\n}\n[dir=rtl] .right-11px {\n  right: auto;\n  left: 11px;\n}\n[dir=rtl] .right-12px {\n  right: auto;\n  left: 12px;\n}\n[dir=rtl] .right-13px {\n  right: auto;\n  left: 13px;\n}\n[dir=rtl] .right-14px {\n  right: auto;\n  left: 14px;\n}\n[dir=rtl] .right-15px {\n  right: auto;\n  left: 15px;\n}\n[dir=rtl] .right-16px {\n  right: auto;\n  left: 16px;\n}\n[dir=rtl] .right-17px {\n  right: auto;\n  left: 17px;\n}\n[dir=rtl] .right-18px {\n  right: auto;\n  left: 18px;\n}\n[dir=rtl] .right-19px {\n  right: auto;\n  left: 19px;\n}\n[dir=rtl] .right-20px {\n  right: auto;\n  left: 20px;\n}\n[dir=rtl] .right-21px {\n  right: auto;\n  left: 21px;\n}\n[dir=rtl] .right-22px {\n  right: auto;\n  left: 22px;\n}\n[dir=rtl] .right-23px {\n  right: auto;\n  left: 23px;\n}\n[dir=rtl] .right-24px {\n  right: auto;\n  left: 24px;\n}\n[dir=rtl] .right-25px {\n  right: auto;\n  left: 25px;\n}\n[dir=rtl] .right-26px {\n  right: auto;\n  left: 27px;\n}\n[dir=rtl] .right-28px {\n  right: auto;\n  left: 28px;\n}\n[dir=rtl] .right-29px {\n  right: auto;\n  left: 29px;\n}\n[dir=rtl] .right-30px {\n  right: auto;\n  left: 30px;\n}\n[dir=rtl] .search-form {\n  margin-right: 20px;\n  margin-left: 0;\n}\n[dir=rtl] .LeftSidebarNav {\n  left: auto;\n  right: 0;\n}\n[dir=rtl] .main-wrapper-content {\n  padding-left: 0;\n  padding-right: 330px;\n}\n[dir=rtl] .main-wrapper-content .main-content {\n  padding-right: 0;\n  padding-left: 30px;\n}\n[dir=rtl] .main-wrapper-content.active {\n  padding-right: 30px;\n}\n[dir=rtl] .main-wrapper-content.active .LeftSidebarNav {\n  left: auto;\n  right: -100%;\n}\n@media only screen and (max-width: 767px) {\n  [dir=rtl] .main-wrapper-content .main-content {\n    padding-left: 15px !important;\n    padding-right: 15px !important;\n  }\n}\n@media only screen and (max-width: 1199px) {\n  [dir=rtl] .main-wrapper-content {\n    padding: 0;\n  }\n  [dir=rtl] .main-wrapper-content .LeftSidebarNav {\n    left: auto;\n    right: -100%;\n    width: 280px;\n  }\n  [dir=rtl] .main-wrapper-content .main-content {\n    padding-left: 30px;\n    padding-right: 30px;\n  }\n  [dir=rtl] .main-wrapper-content.active {\n    padding: 0;\n  }\n  [dir=rtl] .main-wrapper-content.active .LeftSidebarNav {\n    left: auto;\n    right: 0;\n  }\n}\n[dir=rtl] .apexcharts-legend-marker {\n  margin-right: 0;\n  margin-left: 3px;\n}\n[dir=rtl] .apexcharts-yaxis, [dir=rtl] .apexcharts-subtitle-text, [dir=rtl] .apexcharts-title-text {\n  direction: ltr;\n}\n[dir=rtl] .css-1qlw4ct-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper:before, [dir=rtl] .css-1mpld98-MuiPaper-root-MuiMenu-paper-MuiPaper-root-MuiPopover-paper:before {\n  display: none;\n}\n[dir=rtl] .recharts-legend-item .recharts-surface {\n  margin-right: 0;\n  margin-left: 4px;\n}\n[dir=rtl] .ls-search-form input.MuiInputBase-input {\n  padding-right: 15px;\n}\n[dir=rtl] .ls-search-form .search-btn {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .css-s2uf1z {\n  text-align: left;\n}\n[dir=rtl] .MuiAlert-icon {\n  margin-right: 0;\n  margin-left: 12px;\n}\n[dir=rtl] .input-label label {\n  left: auto;\n  right: 0;\n  transform: translate(-15px, 16px) scale(1);\n}\n[dir=rtl] .css-b1hphm-MuiButtonBase-root-MuiChip-root .MuiChip-deleteIcon {\n  margin-right: 0;\n  margin-left: 10px;\n}\n[dir=rtl] .avatars-gap .MuiAvatar-root {\n  margin-left: 16px;\n}\n[dir=rtl] .avatars-gap .MuiAvatar-root:last-child {\n  margin-left: 0;\n}\n[dir=rtl] .gadge-gap .MuiBadge-root {\n  margin-left: 16px;\n}\n[dir=rtl] .gadge-gap .MuiBadge-root:last-child {\n  margin-left: 0;\n}\n[dir=rtl] .MuiButtonBase-root .MuiButton-startIcon {\n  margin-right: 0;\n  margin-left: 8px;\n}\n[dir=rtl] .MuiAlert-root .css-ki1hdl-MuiAlert-action {\n  margin-left: -8px;\n  margin-right: auto;\n}\n[dir=rtl] .chip-gap-for-rtl .MuiChip-root {\n  margin-left: 0;\n  margin-right: 15px;\n}\n[dir=rtl] .chip-gap-for-rtl .MuiChip-root:first-child {\n  margin-right: 0;\n}\n[dir=rtl] .direction-ltr {\n  direction: ltr;\n}\n[dir=rtl] .rtl-step-label .MuiStepLabel-iconContainer {\n  padding-right: 0;\n  padding-left: 10px;\n}\n[dir=rtl] .scroll-to-top i {\n  right: auto;\n  left: 20px;\n}\n[dir=rtl] .control-panel-modal {\n  right: auto;\n  left: -100%;\n}\n[dir=rtl] .control-panel-modal.show {\n  right: auto;\n  left: 0;\n}\n[dir=rtl] .control-panel-modal .settings-btn {\n  right: auto;\n  left: 15px;\n}\n[dir=rtl] .control-panel-dialog {\n  margin-left: 0;\n  margin-right: auto;\n}/*# sourceMappingURL=rtl.css.map */"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
